jQuery(document).ready(function($) {

	$('.responsive-slider--wrapper').each(function(){
		//$(this).flickity($(this).data('flickity'));
	});

});